import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";

export enum ForceVector {
    Unknown = -1,
    Acceleration,
    Deceleration,
    Cornering,
    CorneringLeft,
    CorneringRight,
}

export enum Severity {
    Information,
    Low,
    Medium,
    High,
    Critical
}

export interface IAccelerometerRecord {
    PlotId: number;
    VehicleId?: number;
    EventTime: Date;
    ForceVector: ForceVector;
    ForceValue: number;
    StartingSpeed: number;
    Duration: number;
    Plot: IPlot;
    Vehicle: IVehicle;
    Severity: Severity;
}

export interface IBaseQueryOptions {
    invalidateCache?:  boolean;
}

export interface IDateQueryOptions extends IBaseQueryOptions {
    Start?: string | Date;
    End?: string | Date;
}

export interface IAccelerometerRecordQueryOptions extends IDateQueryOptions {
    PlotId?: number;
    VehicleId?: number;
}

export class AccelerometerRecordService {

    static $inject = ["$http", "$q"];

    constructor(private readonly $http: angular.IHttpService,
        private readonly $q: angular.IQService) {
    }

    getEventsForFleet(queryOptions: IAccelerometerRecordQueryOptions): angular.IPromise<IAccelerometerRecord[]> {
        if (queryOptions.Start) {
            queryOptions.Start = new Date(queryOptions.Start).toISOString();
        }

        if (queryOptions.End) {
            queryOptions.End = new Date(queryOptions.End).toISOString();
        }
        return this.$http({
            url: `/api/accelerometer/records`,
            method: "GET",
            cache: true,
            params: queryOptions
        }).then((response: angular.IHttpPromiseCallbackArg<IAccelerometerRecord[]>) => {
            return response.data;
        });
    }
}
